export const getBidAuctionStatus = state => state.bids.auctionStatus;

export const getBidsCounters = state => state.bids.counters.data;

export const isBidsCountersLoading = state => state.bids.counters.loading;

export const isBidsCountersLoaded = state => state.bids.counters.success;
